import type {
	useTabsHooksPropsType,
	useTabsHookType,
} from "Shared/Components/Tabs/Types/TabType";
import { useEffect, useState } from "react";

export const useStateTabs: (args: useTabsHooksPropsType) => useTabsHookType = ({
	currentTab,
}) => {
	const [activeTab, setActiveTab] = useState(currentTab);

	useEffect(() => {
		setActiveTab(currentTab);
	}, [currentTab]);

	return {
		active: activeTab,
		onChange: (_, index: string) => {
			setActiveTab(index);
		},
	};
};
